import { render, staticRenderFns } from "./KvAttachmentList.vue?vue&type=template&id=953eb29c&scoped=true&"
import script from "./KvAttachmentList.vue?vue&type=script&lang=js&"
export * from "./KvAttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./KvAttachmentList.vue?vue&type=style&index=0&id=953eb29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953eb29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953eb29c')) {
      api.createRecord('953eb29c', component.options)
    } else {
      api.reload('953eb29c', component.options)
    }
    module.hot.accept("./KvAttachmentList.vue?vue&type=template&id=953eb29c&scoped=true&", function () {
      api.rerender('953eb29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/KvAttachmentList.vue"
export default component.exports